import { Group, Stack, Text } from '@mantine/core'
import { format } from 'date-fns'

import { FaIcon } from '#components/FaIcon'
import { UserAvatar } from '#components/UserAvatar'

import { TrackedChange } from './types'

import styles from './Parts.module.css'

export const Attribution = ({
  name,
  avatar,
  timestamp,
}: {
  name: string
  avatar?: string | null
  timestamp?: Date
}) => (
  <Group gap={5} wrap="nowrap">
    <UserAvatar avatarSrc={avatar} alt={name} diameter={20} />
    <Stack gap={0}>
      <Text className={styles.author} span fw="bold" size="sm" lineClamp={1}>
        {name}
      </Text>
      {timestamp && (
        <Text span c="dimmed" size="xs">
          {format(timestamp, "hh:mm aaa 'on' MM/dd/yyyy")}
        </Text>
      )}
    </Stack>
  </Group>
)

export const ReviewerAttribution = ({ thread }: { thread: TrackedChange }) => {
  if (!thread.reviewedAt || !thread.reviewer) return null
  return (
    <>
      <Group gap={5} align="flex-start" className={styles.byline}>
        <Group c="dimmed" align="flex-end" gap={5}>
          {thread.status === 'approved' ? (
            <>
              <FaIcon icon="fa-check" c="dimmed" />
              <Text size="sm">Approved by:</Text>
            </>
          ) : (
            <>
              <FaIcon icon="fa-ban" c="dimmed" />
              <Text size="sm">Declined by:</Text>
            </>
          )}
        </Group>
        <Attribution
          name={thread.reviewer?.name}
          avatar={thread.reviewer.avatar}
        />
      </Group>
    </>
  )
}

export const Snippet = ({
  text,
  isAddition,
}: {
  text: string
  isAddition: boolean
}) => {
  const isEmpty = !text.trim()

  return (
    <Stack gap={2} pt={5}>
      <Text c="gray" size="sm">
        {isAddition ? 'Added' : ' Removed'}:
      </Text>
      {isEmpty ? (
        <EmptyText isAddition={isAddition} text={text} />
      ) : (
        <Text
          c={isAddition ? 'green' : 'red'}
          className={styles.snippet}
          lineClamp={3}
          ff="courier"
        >
          {text}
        </Text>
      )}
    </Stack>
  )
}

const EmptyText = ({
  text,
  isAddition,
}: {
  text: string
  isAddition: boolean
}) => {
  return (
    <Text className={styles.snippet} lineClamp={3} ff="courier">
      <span
        className={styles.snippet___empty}
        data-variant={isAddition ? 'addition' : 'deletion'}
      >
        {text}
      </span>
    </Text>
  )
}
